export default [
    {
        path: '/warehouse/warehouse-location',
        name: 'warehouse-location',
        props: true,
        component: () => import('@/views/warehouse/warehouse-location/index.vue'),
        meta: {
            pageTitle: 'Warehouse Location',
            breadcrumb: [
                {
                text: 'Warehouse Location',
                active: true,
                },
            ],
        },
    },
    {
        path: '/warehouse/warehouse-location/add',
        name: 'create-warehouse-location',
        component: () => import('@/views/warehouse/warehouse-location/create.vue'),
        meta: {
            pageTitle: 'Create Warehouse Location',
            breadcrumb: [
                {
                text: 'Warehouse Location',
                to: { name: 'warehouse-location' },
                },
                {
                text: 'Create Warehouse Location',
                active: true,
                },
            ],
        },
    },
    {
        path: '/warehouse/warehouse-location/:id',
        name: 'detail-warehouse-location',
        props: true,
        component: () => import('@/views/warehouse/warehouse-location/detail.vue'),
        meta: {
            pageTitle: 'Detail Warehouse Location',
            breadcrumb: [
                {
                text: 'Warehouse Location',
                to: { name: 'warehouse-location' },
                },
                {
                text: 'Detail Warehouse Location',
                active: true,
                },
            ],
        },
    },
]